import SearchIcon from '../../../../assets/icons/searchIcon.svg?react'
import styles from './mobileSearch.module.css'

interface MobileSearchProps {
  onOpenSearch: () => void
}

export function MobileSearch({ onOpenSearch }: MobileSearchProps) {
  return (
    <button
      type="button"
      className={styles.button}
      aria-label="Open search"
      onClick={onOpenSearch}
    >
      <SearchIcon className={styles.icon} />
    </button>
  )
}
